import Image from "next/image";
import SectionHeading from "../about/SectionHeading";


export default function EssentiallyAllHere({isRTL}) {

  const toArabicNumerals = (number) => {
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return number
      .toString()
      .split('')
      .map((digit) => arabicNumbers[parseInt(digit)])
      .join('');
  };

  const steps = [
    {
      title: "Ask for a free consultation",
      description:
        isRTL ? "اطلب استشارة مجانية لمناقشة الأفكار والاقتراحات والتوصيات، وفهم احتياجات عملك وتلبيتها، واحصل على عرض للسعر": "Ask for a free consultation to discuss concept ideas, suggestions, and recommendation to understand and fulfil your business needs, and get a quotation",
      icon: "/icons/step1.svg",
    },
    {
      title: "Receive draw layouts, schedule, and plan",
      description:
        isRTL ? "احصل على المخططات المرسومة، والجدول الزمني والتخطيط لمشروعك بالكامل (زيارات الموقع، الموافقات، الرسومات الفنية/ الميكانيكية، والجدول الزمني للتسليم)" : "Receive draw layouts, schedule, and plan your project from A to Z (Site visits, approvals, technical\ mechanical drawings, delivery time scale)",
        icon: "/icons/step2.svg",
    },
    {
      title: "Get a 3D sketch",
      description:
        isRTL ? "استلم رسماً ثلاثي الأبعاد للعناصر المراد تصنيعها. ومن ثم، سنقوم بتصنيعها وتنفيذها باستخدام مواد الستانلس ستيل ذات الجودة العالية والممتازة" : "Get a 3D sketch for items to be fabricated. Then, we craft and implement them using high-grade and premium stainless steel materials",
        icon: "/icons/step3.svg",
    },
    {
      title: "Receive the items",
      description:
        isRTL ? "استلم العناصر. سيقوم فريقنا بتركيب الآلات والمعدات وتوزيعها واختبارها للتأكد من أنها تعمل بشكل صحيح" : "Receive the items. Our team handle, install, distribute, and test the items and machines to ensure everything is running properly",
        icon: "/icons/step4.svg",
    },
    {
      title: "Test the high-quality equipment",
      description:
       isRTL ? "جرِّب المعدات عالية الجودة، واستمتع بالتصميم الاحترافي والحلول الذكية، واجعل قائمة الطعام لديك وخدمتك مميزة لدى زبائنك" :  "Test the high-quality equipment, enjoy the smart design and solutions, and make your menu and service on a high-level performance",
        icon: "/icons/step5.svg",
    },
    {
      title: "Ongoing support",
      description:
       isRTL ? "وأخيراً، سيكون فريق الصيانة لدينا جاهزاً دائماً لدعمك في الصيانة الدورية الوقائية للمعدات، وتنظيفها، وإصلاحها، وتوفير قطع الغيار لها عند الحاجة" : "Finally, our service team is always ready to support you with preventive maintenance, equipment cleaning, repairing, and providing spare parts",
        icon: "/icons/step6.svg",
    },
  ];
  
  return (
    <section className="bg-[#F8F8F8] rounded-[40px] p-6 md:p-12 mt-5 md:mt-20">
      <div className=" grid md:grid-cols-[40%_60%] gap-5 3xl:gap-0   ">
        <div>
        <SectionHeading
        isRTL={isRTL}
      subtitle={isRTL ? "كل ما تحتاجه," : "Everything You Need," }
      title={isRTL ? "في مكان واحد" : "All in One Place" }
    />
          <Image
            src="/images/image2.png"
            width={500}
            height={500}
            alt="Interior Concept for a Fully Equipped Commercial Kitchen"
            className="mt-5 md:mt-20 w-[525px] 3xl:w-[600px] rounded-lg shadow-md"
          />
          {/* <p className="font-primary font-semibold text-[#262626] text-sm 3xl:text-base mt-2">
            Interior Concept for a Fully Equipped Commercial Kitchen
          </p> */}
        </div>



        <div>
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-start  border-b  mb-6 last:border-b-0 last:pb-0"
            >
                <div className="px-6">
              <span className="text-red-500 text-[18px] 3xl:text-[22px] font-primary font-semibold">{isRTL ? toArabicNumerals(index + 1) : `0${index + 1}`}</span>
              </div>
              <div className="w-full flex gap-10 xl:gap-0 items-center lg:items-start  justify-between py-1 px-6">
              <div>
                <p className="text-[#262626] max-w-xl xl:max-w-2xl 2xl:max-w-4xl font-primary text-base font-semibold">{step.description}</p>
                <p className="text-gray-600 text-sm mt-1"></p>
              </div>
              <div className=" text-gray-500 text-2xl">
              <img
            src={step.icon}
            alt="icon"
            className="lg:pb-5 lg:pr-5"
          />
              </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
